import { FormattedMessage } from 'react-intl';

const ProjectContact = (props) => {
  const { content, metadata } = props;
  const projectData = metadata || content || {};
  const someContact = projectData?.contact_text;

  return (
    <>
      {someContact && (
        <div className="project-contact-wrapper">
          <h2>
            <FormattedMessage
              id="persons.contact"
              defaultMessage="Kontaktinformationen"
            />
          </h2>
          <div className="contact-details">
            {projectData?.contact_text && (
              <div
                className="project-right-column"
                dangerouslySetInnerHTML={{
                  __html: projectData?.contact_text.data,
                }}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ProjectContact;
